import "./AboutBodywerks.module.css";
import Header from "@/reusable_sections/Header";
import HeroBanner from "./sections/HeroBanner";
import TheDermaCoralStandard from "./sections/TheDermaCoralStandard";
import PractitionerSpotlight from "./sections/PractitionerSpotlight";
import PractitionerSpotlightCopy from "./sections/PractitionerSpotlightCopy";
import WhatWeDo from "./sections/WhatWeDo";
import ReasonsWhyLakshmiPalIsSpecial from "./sections/ReasonsWhyLakshmiPalIsSpecial";
import CallToAction from "./sections/CallToAction";
import ArchitecturalApplications from "./sections/ArchitecturalApplications";
import Footer from "@/reusable_sections/Footer";
import HealingStartMainBanner from "./sections/HealingStartMainBanner";
import ServiceCards from "./sections/ServiceCards";
export default function AboutBodywerksPage() {
  return <div>
      <Header />
      <HeroBanner />
      <TheDermaCoralStandard />
      <ArchitecturalApplications />
      <ServiceCards />
      <PractitionerSpotlight />
      <HealingStartMainBanner />
      <PractitionerSpotlightCopy />
      <WhatWeDo />
      <ReasonsWhyLakshmiPalIsSpecial />
      <CallToAction />
      <Footer />
    </div>;
}